import { h, Component } from 'preact'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants'
import util from '../util';
import MenuObject from "../canvas/menu-object";
import Renderer from '../canvas/renderer';

export default @connect(reduce, actions)
class MONameBorderWidget extends Component {
  constructor() {
    super();

    this.getColorCss = (type) => {
      const $element = this.props.$element;
      if (!$element) return;

      if (type === 'border-bottom' || type === 'border') {
        return util.getMONameBorderColor($element, type);
      }

      let styles = MenuObject.getStyles($element);
      if (styles && styles['mo-name'] && styles['mo-name'][type]) {
        return styles['mo-name'][type];
      } else {
        return '#fff';
      }
    }

    this.applyToAll = (type) => {
      const $element = this.props.$element;
      if (!$element) return;
      if (type === 'border') {
        window.ConfirmationModal.show({
          title: 'Are you sure?',
          body: 'This will apply the current group name border settings to the entire menu.',
          acceptLabel: 'Yes, apply to all',
          declineLabel: 'Cancel',
          onAccept: () => {
            MenuObject.applyToAll($element, MenuObject.applyModes.nameBorder);
          },
          onDecline: () => {
            window.ConfirmationModal.hide()
          }
        });
      } else if (type === 'fill') {
        window.ConfirmationModal.show({
          title: 'Are you sure?',
          body: 'This will apply the current group name fill settings to the entire menu.',
          acceptLabel: 'Yes, apply to all',
          declineLabel: 'Cancel',
          onAccept: () => {
            MenuObject.applyToAll($element, MenuObject.applyModes.nameFill);
          },
          onDecline: () => {
            window.ConfirmationModal.hide()
          }
        });
      }
    }

    this.updateMONameBackgroundOpacity = this.updateMONameBackgroundOpacity.bind(this);
    this.updateMONameBackgroundRadius = this.updateMONameBackgroundRadius.bind(this);
    this.updateMONameLineWidth = this.updateMONameLineWidth.bind(this);
    this.updateMONameBorderWidth = this.updateMONameBorderWidth.bind(this);
  };

  updateMONameBackgroundOpacity(ev) {
    const opacity = ev.target ? ev.target.value / 100 : ev;
    const bg = this.props.moNameBackgroundColor;

    if (bg) {
      const $element = this.props.$element;

      let colorData = $element.attr('data-mo-name-color') ? JSON.parse($element.attr('data-mo-name-color')) :
        { mode: 'no-fill', colors: ['#fff', '#000'] };

      if (colorData.mode !== 'no-fill') {
        colorData = Renderer.addAlphaToColorData(colorData, opacity);

        $element.attr('data-mo-name-color', JSON.stringify(colorData));
        let css = util.getCssFromColorData(JSON.stringify(colorData));

        const patch = {
          type: 'mo-name',
          key: 'background',
          value: css
        };
        MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);
      }
    }
    this.props.updateElementAttribute('moNameBackgroundOpacity', (opacity * 100).toFixed(0));
  }

  updateMONameBackgroundRadius(ev) {
    const val = ev.target.value;
    const patch = { type: 'mo-name', key: 'border-radius', value: `${val / 10 + 'em'}` };
    MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);
    this.props.updateElementAttribute('moNameBackgroundRadius', val);
  }

  updateMONameLineWidth(ev) {
    const val = ev.target.value;
    const width = val / 10 + 'em';
    const color = this.props.moNameLineColor;

    let patch = { type: 'mo-name', key: 'border-bottom', value: `${width} solid ${color}` };
    if (val === "0") {
      patch = { type: 'mo-name', key: 'border-bottom', value: ' ' };
    } else {
      MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 
        { type: 'mo-name', key: 'border', value: ' ' });
      this.props.updateElementAttribute('moNameBorderWidth', 0);
    }

    MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);
    this.props.updateElementAttribute('moNameLineWidth', val);
  }

  updateMONameBorderWidth(ev) {
    const val = ev.target.value;
    const width = val / 10 + 'em';
    const color = this.props.moNameBorderColor;

    let patch = { type: 'mo-name', key: 'border', value: `${width} solid ${color}` };
    if (val === "0") {
      patch = { type: 'mo-name', key: 'border', value: ' ' };
    } else {
      MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 
        { type: 'mo-name', key: 'border-bottom', value: ' ' });
      this.props.updateElementAttribute('moNameLineWidth', 0);
    }

    MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);
    this.props.updateElementAttribute('moNameBorderWidth', val);
  }

  render(props, state) {
    return (
      <div className="dropdown">
        {!this.props.isFromAside && <a className="dropdown-toggle icn rwd-icon">Border</a>}
        <div className={`${!this.props.isFromAside ? 'dropdown-menu' : ''} border-mo`} data-close="no">
          <div className={'position-header'}>Border</div>
          <div className={'apply-to-all btn secondary1'} onClick={() => this.applyToAll('border')}>Apply to all</div>
          <ul className="slider-list">
            <li className="color-item">
              <div className="border-color">
                <label>Color</label>
                <div onClick={() => this.props.openColorPicker(constants.pickerTypes.moNameBorder)}>
                  <span className="color-box" style={`background: ${this.getColorCss('border')}; float: none;`}></span>
                </div>
              </div>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Width</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="25" step="1" value={this.props.moNameBorderWidth} onChange={this.updateMONameBorderWidth} />
                </div>
                <input className="value" type="number" min="0" max="25" step="1" disabled="disabled" value={this.props.moNameBorderWidth} />
              </div>
            </li>
            <li className="slider-item border-radius">
              <div className={'slider-wrap'}>
                <label>Radius</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="100" step="1" value={this.props.moNameBackgroundRadius} onChange={this.updateMONameBackgroundRadius} onMouseMove={this.updateMONameBackgroundRadius} />
                </div>
                <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={this.props.moNameBackgroundRadius} />
              </div>
            </li>
          </ul>

          <div className={'position-header margin-top'}>Fill</div>
          <div className={'apply-to-all fill-apply btn secondary1'} onClick={() => this.applyToAll('fill')}>Apply to all</div>
          <ul className="slider-list">
            <li className="color-item">
              <div className="border-color fill">
                <label>Color</label>
                <div onClick={() => this.props.openColorPicker(constants.pickerTypes.moNameFill)}>
                  <span className="color-box" style={`background: ${this.getColorCss('background')}; float: none;`}></span>
                </div>
              </div>
            </li>

            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Opacity</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="100" step="1" value={this.props.moNameBackgroundOpacity} onChange={this.updateMONameBackgroundOpacity} onMouseMove={this.updateMONameBackgroundOpacity} />
                </div>
                <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={Math.round(this.props.moNameBackgroundOpacity)} />
              </div>
            </li>

            <li className="slider-item border-radius">
              <div className={'slider-wrap'}>
                <label>Radius</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="100" step="1" value={this.props.moNameBackgroundRadius} onChange={this.updateMONameBackgroundRadius} onMouseMove={this.updateMONameBackgroundRadius} />
                </div>
                <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={this.props.moNameBackgroundRadius} />
              </div>
            </li>
          </ul>

          <div className={'position-header margin-top'}>Line</div>
          <div className={'apply-to-all notes-apply btn secondary1'} onClick={() => this.applyToAll('border')}>Apply to all</div>
          <ul className="slider-list">
            <li className="color-item">
              <div className="border-color">
                <label>Color</label>
                <div onClick={() => this.props.openColorPicker(constants.pickerTypes.moNameLine)}>
                  <span className="color-box" style={`background: ${this.getColorCss('border-bottom')}; float: none;`}></span>
                </div>
              </div>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Width</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="25" step="1" value={this.props.moNameLineWidth} onChange={this.updateMONameLineWidth} />
                </div>
                <input className="value" type="number" min="0" max="25" step="1" disabled="disabled" value={this.props.moNameLineWidth} />
              </div>
            </li>
          </ul>
        </div>
      </div>);
  };
}
